import script from "./AppTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTextField.vue?vue&type=script&setup=true&lang=ts"

import "./AppTextField.vue?vue&type=style&index=0&id=38753724&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38753724"]])

export default __exports__